export default __webpack_public_path__ + "static/media/helpLogo.ea9ee8e3.svg";